<template lang="pug">
.users-guest-screen
  .row
    .col-12
      .row
        .col-12.col-md-5.col-lg-6
          .form-group.form-group--search
            .form-control-icon--end-line
              input#name.form-control.rounded-3(
                :placeholder='$t("pages.usersGuest.searchPlaceholder")'
                @input='searchUsersOrganization()'
                autocomplete='off'
                v-model='filters.search'
              )
              icon(name='magnifying-glass')
        .col-12.col-md-3.col-lg-3.col--bar.mb-4(
          v-if='this.usersOrganization.data.length > 0'
        )
          .users-limit(v-if='usersPlanLimit')
            .bar
              icon.icon--blue(name='user')
              .progress
                .progress-bar.bg-warning(
                  :aria-valuenow='(totalOrganizationUsers / usersPlanLimit) * 100'
                  :style='`width: ${(totalOrganizationUsers / usersPlanLimit) * 100}%`'
                  aria-label='Warning example'
                  aria-valuemax='100'
                  aria-valuemin='0'
                  role='progressbar'
                )
            span.text {{ totalOrganizationUsers }} {{ $t('pages.usersGuest.of') }} {{ usersPlanLimit }} {{ $t('pages.usersGuest.users') }}
          .users-limit-postpaid(v-else)
            icon.icon--blue(name='user')
            span.text
              strong {{ totalOrganizationUsers }}
              | {{ $t('pages.usersGuest.users') }}
        .col-12.col-md-4.col-lg-3.text-end.col--action(
          v-if='this.usersOrganization.data.length > 0'
        )
          .btn-invite-user
            .text-end
              button.btn.btn-primary.btn--invite-user(
                :disabled='usersPlanLimit && totalOrganizationUsers >= usersPlanLimit'
                @click='openInviteUserModal'
              )
                | {{ $t('pages.usersGuest.inviteUser') }}
    .col-12(v-if='this.usersOrganization.data.length > 0')
      users-guest-card-table(
        :data='usersOrganization.data'
        @item-deleted='fetchUsers'
        @item-updated='fetchUsers'
      )
      simple-paginator(:payload='usersOrganization' @navigate='fetchUsers')
  .text-center.mt-5(v-if='!(this.usersOrganization.data.length > 0)')
    img.img-fluid.mt-5(src='/img/ilustrations/no-guest-users.svg')
    p.font-color-blue.mt-4
      | {{ $t('pages.usersGuest.noUsers') }}
      br
      | {{ $t('pages.usersGuest.startNow') }}
    button.btn.btn-primary(
      :disabled='usersOrganization.data.length >= usersPlanLimit'
      @click='openInviteUserModal'
    ) {{ $t('pages.usersGuest.inviteUser') }}
  invite-user-modal(
    @invites-sent='fetchOrganizationStats()'
    ref='inviteUserModal'
  )
  invite-limit-reached-modal(ref='inviteLimitReachedModal')
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import UsersService from '@/services/UsersService';
import InvitationService from '@/services/InvitationService';
import debounce from 'debounce';
import SimplePaginator from '@/ui/organisms/SimplePaginator.vue';
import InviteUserModal from '@/modules/account/components/organisms/modals/InviteUserModal.vue';
import alert from '@/modules/account/common/alert';
import UsersGuestCardTable from '@/modules/account/components/organisms/card-table/UsersGuestCardTable.vue';
import OrganizationsHttp from '@/modules/business/services/http/organizations/OrganizationsService';
import InviteLimitReachedModal from '@/modules/account/components/organisms/modals/InviteLimitReachedModal.vue';
export default {
  name: 'UsersGuest',
  components: {
    Icon,
    UsersService,
    InvitationService,
    SimplePaginator,
    InviteUserModal,
    UsersGuestCardTable,
    InviteLimitReachedModal,
  },
  data() {
    return {
      usersOrganization: {
        data: [],
        links: {},
        meta: {},
      },
      filters: {
        search: '',
      },
      totalOrganizationUsers: 0,
    };
  },
  async created() {
    this.$store.dispatch('page/setTitle', this.$t('pages.usersGuest.title'));
    this.$store.dispatch('page/setHead', this.$t('pages.usersGuest.head'));
    this.$store.dispatch('page/setClass', 'accounts users guestusers');

    await this.fetchOrganizationStats();
    await this.fetchUsers();

    if (
      this.usersPlanLimit &&
      this.totalOrganizationUsers >= this.usersPlanLimit
    ) {
      this.$refs.inviteLimitReachedModal.open();
    }
  },
  computed: {
    usersPlanLimit() {
      if (!this.$store.state.subscription.plan.plan) {
        return false;
      }
      const limit = this.$store.state.subscription.plan.plan.limits
        .filter((i) => i.limitation === 'users')
        .shift();
      if (!limit) {
        return false;
      }
      return limit.quantity;
    },
  },
  methods: {
    fetchUsers(page = 1) {
      this.$loading(true);

      UsersService.supressDefault = true;
      const params = new URLSearchParams({
        ...(this.filters.search && { q: this.filters.search }),
        ...{ page },
      });
      return UsersService.list(params.toString())
        .then((response) => {
          this.usersOrganization = response.data;
          this.usersOrganization.data.sort((a, b) => {
            const currentUserId = this.$root.user.id;
            if (a.id === currentUserId) return -1;
            if (b.id === currentUserId) return 1;
            if (a.is_owner && !b.is_owner) return -1;
            if (!a.is_owner && b.is_owner) return 1;
            return 0;
          });
        })
        .catch((error) => {
          alert.fireAlert(
            `${this.$t('pages.usersGuest.errorNoListUsers')} ${
              error.response.data.message
            }`,
            {
              classes: 'alert-danger',
              styles:
                'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
              tag: 'httpAlert',
              icon: 'triangle-exclamation',
            }
          );
        })
        .finally(() => {
          UsersService.supressDefault = false;
          this.$loading(false);
        });
    },
    setUserIdToSendModal(id) {
      this.selectedUserId = id;
    },
    searchUsersOrganization: debounce(function searchUsersOrganization() {
      this.fetchUsers();
    }, 300),
    openInviteUserModal() {
      this.$refs.inviteUserModal.$refs.modal.open();
    },
    fetchOrganizationStats() {
      const selected = this.$store.state['organizations'].selected;
      return OrganizationsHttp.getStats(selected.id).then((res) => {
        this.totalOrganizationUsers = res.data.invitations + res.data.users;
      });
    },
  },
};
</script>
<style lang="stylus">
.users-guest-screen
  .btn--invite-user
    margin-bottom: 2rem
    width: 100%
  .users-limit
    min-width: 165px
    height: fit-content
    margin-top: .5rem
    position: relative
    font-size: .9em
    .progress, .text
      margin-left: 1.5rem
    .progress
      height: .85em
      border-radius: 1rem
    .text
      font-size: .9em
    .icon
      top: -2px
      position: absolute
  .users-limit-postpaid
    text-align: end
    min-width: 165px
    height: fit-content
    margin-top: .8rem
    position: relative
    font-size: .9em
    .text
      font-size: .9em
      margin-left: 1.5rem
    .icon
      top: 2px
      position: absolute

@media (min-width: 992px)
  .users-guest-screen
    .btn--invite-user
      max-width: 180px
    .col--action
      max-width: 200px
    .col--bar
      max-width: 200px
      margin-left: auto
    .form-group--search
      max-width: 320px
@media (min-width: 1200px)
  .manage-applications-card-table__name
    max-width: 470px
</style>
